import React, { useContext, useEffect, useMemo, useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import apiService from "../../services/api-service";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import GenericForm from "../genericForm";
import { Autocomplete, Button, Checkbox, FormControlLabel, IconButton, TextField } from "@mui/material";
// GraphQL imports removed - now using REST endpoints
// import { tenant } from "../../tenant"; // No longer needed for REST endpoints
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./CalendarStyles.css";
import MDTypography from "../../components/MDTypography";
import GenericTable from "../genericTable";
import { createMRTColumnHelper } from "material-react-table";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Tabs, Tab, Box } from "@mui/material";
import { AuthContext } from "../../context";
import MDAlert from "../../components/MDAlert";
import { useSelector, useDispatch } from "react-redux";
import { saveDate } from "../../dateSlice";
import Typography from "@mui/material/Typography";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import HourAdd from "./hourAdd";
import HourDetail from "./hourDetail";
import GenericDynamicTable from "../GenericDynamicTable";
import showToast from "../../utils/toast";
import MachineryDateCopy from "./MachineryDateCopy";
import WbsDateCopy from "./WbsDateCopy";
import HoursDateCopy from "./HoursDateCopy";

const tabs = ["WBS", "Macchinari", "Suddivisione ore", "Note giornaliere"];

function JournalActivity() {
	const authContext = useContext(AuthContext);
	const [notesFormData, setNotesFormData] = useState({});
	const [wbsOption, setWbsOption] = useState([]);
	const [wbsData, setWbsData] = useState([]);
	const [originalWbsData, setOriginalWbsData] = useState([]);
	const [appeals, setAppeals] = useState([]);
	const dispatch = useDispatch();
	const savedState = useSelector((state) => {
		return state.date;
	});
	const [state, setState] = useState(savedState);
	const columnHelper = createMRTColumnHelper();
	const [selectedTab, setSelectedTab] = useState(0);
	const [machineries, setMachineries] = useState([]);
	const [selectedMachineries, setSelectedMachineries] = useState({});
	const [filteredMachineries, setFilteredMachineries] = useState([]);
	const [suppliers, setSuppliers] = useState([]);
	const [filteredSuppliers, setFilteredSuppliers] = useState([]);
	const [isCalendarOpen, setIsCalendarOpen] = useState(false);
	const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
	const [isWbsCopyModalOpen, setIsWbsCopyModalOpen] = useState(false);
	const [isHoursCopyModalOpen, setIsHoursCopyModalOpen] = useState(false);
	const copyButtonConfig = useMemo(() => {
		if (selectedTab === tabs.indexOf("WBS")) {
			return {
				label: "Copia WBS da data precedente",
				onClick: () => setIsWbsCopyModalOpen(true),
			};
		}
		if (selectedTab === tabs.indexOf("Macchinari")) {
			return {
				label: "Copia macchinari da data precedente",
				onClick: () => setIsCopyModalOpen(true),
			};
		}
		if (selectedTab === tabs.indexOf("Suddivisione ore")) {
			return {
				label: "Copia suddivisione ore da data precedente",
				onClick: () => setIsHoursCopyModalOpen(true),
			};
		}
		return null;
	}, [selectedTab]);

	const [datesAlreadyFilled, setDatesAlreadyFilled] = useState([]);
	const [activeStartDate, setActiveStartDate] = useState(new Date());
	// Definiamo una funzione che limita la selezione delle date al massimo fino ad oggi
	const tileDisabled = ({ date }) => {
		const today = new Date();
		// Disabilita le date future
		return date > today;
	};

	const handleSetNotification = (msg, severityType) => {
		showToast(msg, severityType);
	};

	const handleActiveStartDateChange = ({ activeStartDate, view }) => {
		setActiveStartDate(activeStartDate);
	};

	const isMarked = (date) => {
		return datesAlreadyFilled.some(
			(marked) =>
				marked.getFullYear() === date.getFullYear() && marked.getMonth() === date.getMonth() && marked.getDate() === date.getDate()
		);
	};

	function transformData(data) {
		// Crea una mappa per cercare rapidamente i nodi tramite job_id
		const jobMap = new Map();
		const roots = [];

		// Step 1: Prepara i nodi e popola la mappa
		data.forEach((item) => {
			const { id, name, job } = item;
			const { code, father_id, job_id } = job;

			const node = {
				id,
				code,
				name,
				group: code,
				done_today: false,
				view_on_gdl: false,
				extra: false,
				subRows: [],
			};

			jobMap.set(job_id, node);

			// Se il father_id è null, è una radice
			if (father_id === null) {
				roots.push(node);
			}
		});

		// Step 2: Collega i figli alle rispettive radici
		data.forEach((item) => {
			const { job } = item;
			const { father_id, job_id, code } = job;

			// Solo se ha un father_id, va aggiunto come figlio
			if (father_id !== null) {
				const parentNode = jobMap.get(father_id);
				if (parentNode) {
					parentNode.subRows.push({
						id: item.id,
						code: `${parentNode.code}-${code}`,
						name: item.name,
						group: parentNode.group,
						done_today: false,
						view_on_gdl: false,
						extra: false,
					});
				}
			}
		});

		// Step 3: Ritorna solo le radici
		return roots;
	}

	function getWbsOption(data) {
		const result = [];

		// Funzione ricorsiva per elaborare righe e subRows
		function processRow(row, parentCode = null) {
			const name = parentCode ? `${parentCode}-${row.code.split("-").pop()} - ${row.name}` : row.code + " - " + row.name;
			result.push({ id: row.id, name });

			// Se ci sono subRows, elaborale
			if (row.subRows && row.subRows.length > 0) {
				for (const subRow of row.subRows) {
					processRow(subRow, row.code);
				}
			}
		}

		// Itera su ogni elemento principale nell'array
		for (const row of data) {
			processRow(row);
		}

		return result;
	}

	function getAppeals() {
		apiService
			.get("/appeal-management/", {
				id: localStorage.getItem("areaSelected"),
				date: dayjs(state.date).format("YYYY-MM-DD"),
			})
			.then((data) => {
				if (data && Array.isArray(data)) setAppeals(data);
			})
			.catch((error) => {
				handleSetNotification(
					"Qualcosa è andato storto durante il caricamento delle presenze. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #44637439",
					"error"
				);
			});
	}

	function getDailyJobs(wbs) {
		apiService
			.get(
				"/daily-jobs-management/",
				{
					date: dayjs(state.date).format("YYYY-MM-DD"),
					area_id: localStorage.getItem("areaSelected"),
				},
				{}
			)
			.then((data) => {
				if (data) {
					setWbsData([...data]);
					setOriginalWbsData(JSON.parse(JSON.stringify(data)));
				}
			})
			.catch((error) =>
				handleSetNotification(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00058261826380",
					"error"
				)
			);
	}

	function getActivity() {
		apiService
			.get("/jobs-area/wbs/", {
				area_id: localStorage.getItem("areaSelected"),
			})
			.then((data) => {
				if (data && Array.isArray(data)) {
					let new_data = transformData(data);
					let option = getWbsOption(new_data);
					setWbsOption(option);
					getDailyJobs(new_data);
				}
			})
			.catch((error) => {
				handleSetNotification(
					"Qualcosa è andato storto durante il caricamento delle presenze. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #44637439",
					"error"
				);
			});
	}

	const isMachineSelected = (id) => {
		return Boolean(selectedMachineries[id]?.selected);
	};

	const isMachineViewOnGDL = (id) => {
		return Boolean(selectedMachineries[id]?.view_on_GDL);
	};

	useEffect(() => {
		getActivity();
	}, []);

	useEffect(() => {
		getAppeals();
		getDailyJobs(wbsData);
		setSelectedTab(0);
		apiService
			.get(
				"/daily-notes-management/",
				{
					area: localStorage.getItem("areaSelected"),
					date: dayjs(state.date).format("YYYY-MM-DD"),
				},
				{}
			)
			.then((data) => {
				setNotesFormData({
					...data,
					area: localStorage.getItem("areaSelected"),
					date: dayjs(state.date).format("YYYY-MM-DD"),
				});
			})
			.catch((error) =>
				handleSetNotification(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #004535",
					"error"
				)
			);

		apiService
			.get("/machineries-management/", {}, {})
			.then((data) => {
				setMachineries(data);
				const uniqueSuppliers = [...new Set(data.map((item) => item.supplier_name).filter(Boolean))];
				setSuppliers(uniqueSuppliers);
			})
			.catch((error) => {
				handleSetNotification(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #004535",
					"error"
				);
			});

		apiService
			.get(
				"/daily-machines-management/",
				{
					area: localStorage.getItem("areaSelected"),
					date: dayjs(state.date).format("YYYY-MM-DD"),
				},
				{}
			)
			.then((data) => {
				setSelectedMachineries({});
				data.forEach((machine) => {
					setSelectedMachineries((prev) => ({
						...prev,
						[machine.id]: { ...machine, selected: true },
					}));
				});
			})
			.catch((error) =>
				handleSetNotification(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #5323104535",
					"error"
				)
			);
	}, [state.date]);

	useEffect(() => {
		const fetchDates = async () => {
			try {
				const response = await apiService.get("/appeal-management/dates", {
					id: localStorage.getItem("areaSelected"),
					month: dayjs(activeStartDate).format("MM"),
					year: dayjs(activeStartDate).format("YYYY"),
				});
				console.log("response", response);
				setDatesAlreadyFilled((prev) => {
					const allDates = [...prev, ...response.dates.map((date) => new Date(date))];
					const uniqueDatesMap = new Map();
					allDates.forEach((d) => {
						const key = d.toISOString().slice(0, 10);
						if (!uniqueDatesMap.has(key)) {
							uniqueDatesMap.set(key, d);
						}
					});
					return Array.from(uniqueDatesMap.values());
				});
			} catch (_) {}
		};

		fetchDates();
	}, [activeStartDate]);

	const columnsWBS = [
		columnHelper.accessor("id_jobarea", {
			header: "Codice",
			size: 30,
			Cell: ({ row }) => {
				return (
					<Autocomplete
						options={wbsOption || []}
						value={row?.original?.id_jobarea}
						onChange={(event, value) => {
							let updatedData = [...wbsData];
							updatedData[row.index].id_jobarea = value;
							setWbsData(updatedData);
						}}
						getOptionLabel={(option) => {
							return option.name || "";
						}}
						isOptionEqualToValue={(option, value) => {
							return option.id === value.id;
						}}
						renderInput={(params) => <TextField {...params} variant="outlined" label="Codice della lavorazione" />}
					/>
				);
			},
		}),

		columnHelper.accessor("description", {
			header: "Descrizione",
			size: 120,
			Cell: ({ row }) => {
				const [description, setDescription] = useState(row.original.description);
				const descriptionDebounceRef = useRef();

				useEffect(() => {
					if (descriptionDebounceRef.current) {
						clearTimeout(descriptionDebounceRef.current);
					}
					descriptionDebounceRef.current = setTimeout(() => {
						const updatedData = [...wbsData];
						updatedData[row.index].description = description;
						setWbsData(updatedData);
					}, 1000);
				}, [description]);

				return (
					<TextField
						variant="outlined"
						size="large"
						sx={{ width: "100%" }}
						defaultValue={description}
						onChange={(e) => {
							setDescription(e.target.value);
						}}
					/>
				);
			},
		}),
		columnHelper.accessor("view_on_GDL", {
			header: "GDL",
			size: 30,
			typeOfValue: "boolean",
			defaultValue: true,
			Cell: ({ row }) => {
				return (
					<Checkbox
						checked={Boolean(row.original.view_on_GDL)}
						onChange={(e) => {
							const value = e.target.checked;
							const updatedData = [...wbsData];
							updatedData[row.index].view_on_GDL = value;
							setWbsData(updatedData);
						}}
						sx={{
							transform: "scale(1.5)", // Ingrandisce la Checkbox di 1.5 volte
							"& .MuiSvgIcon-root": { fontSize: 28 }, // Ingrandisce l'icona all'interno della Checkbox
						}}
					/>
				);
			},
		}),
	];

	const handleDateChange = (newDate) => {
		setState((prevState) => ({ ...prevState, date: newDate }));
		dispatch(saveDate({ date: newDate }));
		setIsCalendarOpen(false);
	};

	return authContext.hasAuth("VIEW_DAILYACTIVITY") ? (
		<>
			<DashboardLayout>
				<DashboardNavbar />
				<center>
					<div className="calendar-container">
						<div
							style={{
								display: !isCalendarOpen ? "none" : "block",
							}}
						>
							<Calendar
								onChange={handleDateChange}
								value={state.date}
								tileDisabled={tileDisabled}
								maxDate={new Date()}
								className="custom-calendar"
								onActiveStartDateChange={handleActiveStartDateChange}
								tileContent={(date, view) => {
									if (isMarked(date.date)) {
										return <div className="circle-marker"></div>;
									}
									return null;
								}}
							/>
						</div>
						<MDBox
							sx={{
								mt: 2,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: "16px",
								flexWrap: "wrap",
								marginBottom: "30px",
							}}
						>
							<Button
								onClick={() => setIsCalendarOpen(!isCalendarOpen)}
								variant="contained"
								color="primary"
								sx={{
									minWidth: "120px",
									color: "#ffffff",
								}}
							>
								{isCalendarOpen ? "Chiudi calendario" : "Apri calendario"}
							</Button>

							<MDTypography fontWeight="bold" sx={{ textTransform: "uppercase" }}>
								{state.date.toLocaleDateString("it-IT", {
									weekday: "long",
									year: "numeric",
									month: "2-digit",
									day: "2-digit",
								})}
							</MDTypography>

							{copyButtonConfig && (
								<Button
									variant="contained"
									color="primary"
									onClick={copyButtonConfig.onClick}
									sx={{
										minWidth: "180px",
										color: "#ffffff",
										backgroundColor: "#514f4f",
										color: "white!important",
									}}
								>
									{copyButtonConfig.label}
								</Button>
							)}
						</MDBox>
					</div>
				</center>
				<MDBox
					sx={{
						width: "100%",
						marginTop: "20px",
						maxWidth: "2400px",
					}}
				>
					{appeals.length > 0 && (
						<Tabs
							value={selectedTab}
							onChange={(e, newValue) => setSelectedTab(newValue)}
							indicatorColor="primary"
							textColor="primary"
							centered
						>
							{tabs.map((tab, index) => (
								<Tab key={index} label={tab} />
							))}
						</Tabs>
					)}
					<MDBox
						sx={{
							width: "100%",
							marginTop: "20px",
							maxWidth: "2400px",
						}}
					>
						{appeals.length > 0 ? (
							<>
								{selectedTab === tabs.indexOf("Note giornaliere") && (
									<GenericForm
										useAPI={true} // cambia a true per usare l'API
										executeOnSuccess={true}
										url="/daily-notes-management/"
										old_data={notesFormData}
										saveStyle={{
											backgroundColor: "#514f4f",
											color: "white!important",
											width: "220px",
											height: "50px",
											fontSize: "16px",
										}}
										executeOnSuccessTask={() => {
											apiService
												.get(
													"/daily-notes-management/",
													{
														area: localStorage.getItem("areaSelected"),
														date: dayjs(state.date).format("YYYY-MM-DD"),
													},
													{}
												)
												.then((data) => {
													setNotesFormData({
														...data,
														area: localStorage.getItem("areaSelected"),
														date: dayjs(state.date).format("YYYY-MM-DD"),
													});
												})
												.catch((error) =>
													handleSetNotification(
														"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #004535",
														"error"
													)
												);
										}}
										inputFields={[
											{
												type: "adder",
												name: "notes",
												label: "Aggiungi note",
												fieldForEachInstance: [
													{
														type: "text",
														name: "notes",
														label: "Nota",
														multiline: true,
														rows: 5,
													}, // Campo richiesto
													{
														type: "switch",
														name: "view_on_GDL",
														label: "Visualizza sul GDL",
														defaultValue: true,
													}, // Campo opzionale
												],
											},
										]}
									/>
								)}
								{selectedTab === tabs.indexOf("Macchinari") && machineries.length > 0 && (
									<>
										<MDBox sx={{ marginBottom: "20px" }}>
											<MDTypography
												variant="h6"
												sx={{
													marginBottom: "10px",
													textAlign: "center",
												}}
											>
												Filtra fornitori
											</MDTypography>
											<MDBox
												sx={{
													display: "flex",
													border: "1px solid #1976d2",
													borderRadius: "10px",
													padding: "15px",
													overflowX: "auto",
													gap: "10px",
													"&::-webkit-scrollbar": {
														height: "8px",
													},
													"&::-webkit-scrollbar-track": {
														backgroundColor: "#f1f1f1",
														borderRadius: "4px",
													},
													"&::-webkit-scrollbar-thumb": {
														backgroundColor: "#888",
														borderRadius: "4px",
													},
													"&::-webkit-scrollbar-thumb:hover": {
														backgroundColor: "#555",
													},
												}}
											>
												{[...suppliers].map((supplier, i) => (
													<Button
														key={i}
														variant={filteredSuppliers.includes(supplier) ? "contained" : "outlined"}
														color="primary"
														sx={{
															minWidth: "120px",
															whiteSpace: "nowrap",
															backgroundColor: filteredSuppliers.includes(supplier) ? "#1976d2" : "#ffffff",
															color: filteredSuppliers.includes(supplier) ? "#ffffff" : "#1976d2",
															borderColor: "#1976d2",
															"&:hover": {
																backgroundColor: filteredSuppliers.includes(supplier)
																	? "#1565c0"
																	: "#f5f5f5",
															},
														}}
														onClick={() => {
															setFilteredSuppliers((prev) =>
																prev.includes(supplier)
																	? prev.filter((s) => s !== supplier)
																	: [...prev, supplier]
															);
														}}
													>
														{supplier}
													</Button>
												))}
											</MDBox>
										</MDBox>

										<MachineryDateCopy
											open={isCopyModalOpen}
											onClose={() => setIsCopyModalOpen(false)}
											onCopyMachineries={(pastMachineries) => {
												const newSelectedMachineries = {};
												console.log("pastMachineries", pastMachineries);
												console.log("selectedMachineries", selectedMachineries);

												pastMachineries.forEach((machine) => {
													newSelectedMachineries[machine.id] = {
														id: machine.id,
														selected: true,
														view_on_GDL: machine.view_on_GDL,
													};
												});
												console.log("newSelectedMachineries", newSelectedMachineries);
												setSelectedMachineries(newSelectedMachineries);
											}}
										/>

										<GenericTable
											data={
												filteredSuppliers.length > 0
													? machineries.filter((machine) => filteredSuppliers.includes(machine.supplier_name))
													: machineries
											}
											columns={[
												columnHelper.accessor("name", {
													header: "Nome macchinario",
													Cell: ({ row }) => (
														<MDTypography variant="caption" fontWeight="medium">
															{row.original.name}
														</MDTypography>
													),
												}),
												columnHelper.accessor("supplier", {
													header: "Fornitore",

													Cell: ({ row }) => (
														<MDTypography variant="caption">{row.original.supplier_name}</MDTypography>
													),
												}),
												columnHelper.accessor("selected", {
													header: "Utilizzato",
													Cell: ({ row }) => (
														<Checkbox
															checked={isMachineSelected(row.original.id)}
															onChange={(e) => {
																const value = e.target.checked;
																setSelectedMachineries((prev) => ({
																	...prev,
																	[row.original.id]: {
																		id: row.original.id,
																		selected: value,
																		view_on_GDL: value
																			? selectedMachineries[row.original.id]?.view_on_GDL || true
																			: false,
																	},
																}));
															}}
														/>
													),
												}),
												columnHelper.accessor("view_on_GDL", {
													header: "GDL",
													Cell: ({ row }) => (
														<Checkbox
															checked={isMachineViewOnGDL(row.original.id)}
															onChange={(e) => {
																const value = e.target.checked;
																setSelectedMachineries((prev) => ({
																	...prev,
																	[row.original.id]: {
																		...prev[row.original.id],
																		view_on_GDL: value,
																	},
																}));
															}}
														/>
													),
												}),
											]}
											enableRowSelection={false}
											enableColumnFilters={false}
											enableGlobalFilter={true}
											enablePagination={true}
											initialState={{
												pagination: {
													pageSize: 5,
													pageIndex: 0,
												},
											}}
										/>

										<div
											style={{
												display: "flex",
												justifyContent: "end",
												alignItems: "center",
												gap: "10px",
												marginTop: "20px",
											}}
										>
											<Button
												variant="contained"
												color="primary"
												sx={{
													backgroundColor: "#514f4f",
													color: "white!important",
													width: "220px",
													height: "50px",
													fontSize: "16px",
												}}
												onClick={() => {
													apiService
														.post(
															"/daily-machines-management/",
															{
																"Content-Type": "application/json",
															},
															{
																machineries: Object.values(selectedMachineries).filter(
																	(machine) => machine.selected
																),
																date: dayjs(state.date).format("YYYY-MM-DD"),
																area: localStorage.getItem("areaSelected"),
															}
														)
														.then((response) => {
															handleSetNotification("Macchinari salvati con successo", "success");
														})
														.catch((error) => {
															handleSetNotification(
																"Errore durante il salvataggio dei macchinari. Riprova più tardi.",
																"error"
															);
														});
												}}
											>
												Salva macchinari
											</Button>
											<Button
												variant="contained"
												color="primary"
												sx={{
													backgroundColor: "#514f4f",
													color: "white!important",
													width: "220px",
													height: "50px",
													fontSize: "16px",
												}}
												onClick={() => {
													setSelectedTab(tabs.indexOf("Suddivisione ore"));
												}}
											>
												Prossima scheda
											</Button>
										</div>
									</>
								)}
								{selectedTab === tabs.indexOf("WBS") && (
									<>
										<WbsDateCopy
											open={isWbsCopyModalOpen}
											onClose={() => setIsWbsCopyModalOpen(false)}
											onCopyWbs={(pastWbs) => {
												const newWbsData = pastWbs.map((item) => ({
													...item,
													id: undefined,
													done_today: item.done_today || false,
													view_on_gdl: item.view_on_gdl || false,
													extra: item.extra || false,
												}));
												setWbsData([...wbsData, ...newWbsData]);
											}}
										/>

										<GenericDynamicTable
											authModelName="DAILYACTIVITY"
											columns={columnsWBS}
											rows={wbsData}
											setRows={setWbsData}
											newLineButtonLabel="Aggiungi Lavorazione"
											newLineButtonFontSize="0.8rem"
										/>

										<div
											style={{
												display: "flex",
												justifyContent: "end",
												alignItems: "center",
												gap: "10px",
												marginTop: "20px",
											}}
										>
											<Button
												variant="contained"
												color="primary"
												disabled={JSON.stringify(wbsData) === JSON.stringify(originalWbsData)}
												sx={{
													backgroundColor: "#514f4f",
													color: "white!important",
													width: "220px",
													height: "50px",
													fontSize: "16px",
												}}
												onClick={() => {
													let old = [];
													let newEl = [];
													for (let i = 0; i < wbsData.length; i++) {
														if (wbsData[i]?.id) {
															old.push(wbsData[i]);
														} else {
															newEl.push(wbsData[i]);
														}
													}
													apiService
														.post(
															"/daily-jobs-management/",
															{},
															{
																area: localStorage.getItem("areaSelected"),
																date: dayjs(state.date).format("YYYY-MM-DD"),
																old_jobs: old,
																new_jobs: newEl,
															}
														)
														.then((data) => {
															handleSetNotification("Operazione effettuata con successo", "success");
															getDailyJobs(wbsData);
														})
														.catch((error) => {
															handleSetNotification(
																"Errore durante l'operazione. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00080",
																"error"
															);
															getDailyJobs(wbsData);
														});
												}}
											>
												Salva
											</Button>
											<Button
												variant="contained"
												color="primary"
												sx={{
													backgroundColor: "#514f4f",
													color: "white!important",
													fontSize: "16px",
													width: "220px",
													height: "50px",
												}}
												onClick={() => {
													setSelectedTab(tabs.indexOf("Macchinari"));
												}}
											>
												Prossima scheda
											</Button>
										</div>
									</>
								)}
								{selectedTab === tabs.indexOf("Suddivisione ore") && (
									<>
										<HoursDateCopy
											open={isHoursCopyModalOpen}
											onClose={() => setIsHoursCopyModalOpen(false)}
											onCopyHours={(pastHours) => {
												console.log("Copying hours data:", pastHours);
												handleSetNotification("Dati ore copiati con successo", "success");
											}}
										/>
										<HourDetail
											date={state.date}
											nextTab={() => setSelectedTab(tabs.indexOf("Note giornaliere"))}
											onOpenCopyModal={() => setIsHoursCopyModalOpen(true)}
										/>
									</>
								)}
							</>
						) : (
							<center>
								<MDTypography variant="h5" style={{ marginTop: "10px" }}>
									Non risulta nessun appello registrato per la data selezionata. Se desideri registrare delle nuove wbs,
									ricordati di compilare l'appello prima.
								</MDTypography>
							</center>
						)}
					</MDBox>
				</MDBox>
			</DashboardLayout>
		</>
	) : (
		<DashboardLayout>
			<MDAlert color="error" dismissible>
				<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
			</MDAlert>
		</DashboardLayout>
	);
}

export default JournalActivity;
